import React from "react";
import "../styles.css";
import duckLogo from "../assets/logo.png";

export default function Header() {
  return (
    <div className="header">
      <img className="logo" src={duckLogo} alt="moviedux" />
      <h2 className="app-subtitle">
        It's time for popcorn! Find your next movie here.
      </h2>
    </div>
  );
}
